import type { FieldValues, UseControllerProps } from 'react-hook-form';
import { useController } from 'react-hook-form';

import type { FileInputProps } from '../../inputs';
import { FileInput } from '../../inputs';

type FileInputControllerProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<FileInputProps, 'formError' | 'onFilesUpdate'>;

export const FileInputController = <T extends FieldValues>({
  className,
  label,
  hint,
  acceptedTypes,
  maxFileSize,
  maxFiles,
  errorMessages,
  testId = 'file-input-controller',
  ...controllerProps
}: FileInputControllerProps<T>) => {
  const { field, fieldState } = useController(controllerProps);

  return (
    <FileInput
      className={className}
      label={label}
      hint={hint}
      onFilesUpdate={field.onChange}
      acceptedTypes={acceptedTypes}
      maxFileSize={maxFileSize}
      maxFiles={maxFiles}
      formError={fieldState.error?.message}
      errorMessages={errorMessages}
      testId={testId}
    />
  );
};
